/* eslint-disable no-unused-expressions */
/* eslint-disable  no-undef */
/* eslint-disable  no-sequences */
/* eslint-disable  strict */
/**
 * @license
 * Copyright (c) 2018 amCharts (Antanas Marcelionis, Martynas Majeris)
 *
 * This sofware is provided under multiple licenses. Please see below for
 * links to appropriate usage.
 *
 * Free amCharts linkware license. Details and conditions:
 * https://github.com/amcharts/amcharts4/blob/master/LICENSE
 *
 * One of the amCharts commercial licenses. Details and pricing:
 * https://www.amcharts.com/online-store/
 * https://www.amcharts.com/online-store/licenses-explained/
 *
 * If in doubt, contact amCharts at contact@amcharts.com
 *
 * PLEASE DO NOT REMOVE THIS COPYRIGHT NOTICE.
 * @hidden
 */
am4internal_webpackJsonp(
  ["ab45"],
  {
    lhmh: function (t, e, i) {
      "use strict";
      Object.defineProperty(e, "__esModule", { value: !0 });
      var n = i("aCit"),
        a = function (t) {
          Object(n.b)(t, "SpriteState") && (t.transitionDuration = 400),
            Object(n.b)(t, "Component") &&
              ((t.rangeChangeDuration = 500),
              (t.interpolationDuration = 500),
              (t.sequencedInterpolation = !1),
              Object(n.b)(t, "SankeyDiagram") &&
                (t.sequencedInterpolation = !0),
              Object(n.b)(t, "FunnelSeries") &&
                (t.sequencedInterpolation = !0)),
            Object(n.b)(t, "Chart") &&
              ((t.defaultState.transitionDuration = 2e3),
              (t.hiddenState.transitionDuration = 1e3)),
            Object(n.b)(t, "Tooltip") &&
              ((t.animationDuration = 400),
              (t.defaultState.transitionDuration = 400),
              (t.hiddenState.transitionDuration = 400)),
            Object(n.b)(t, "Scrollbar") && (t.animationDuration = 500),
            Object(n.b)(t, "Series") &&
              ((t.defaultState.transitionDuration = 1e3),
              (t.hiddenState.transitionDuration = 700),
              (t.hiddenState.properties.opacity = 1),
              (t.showOnInit = !0)),
            Object(n.b)(t, "MapSeries") &&
              (t.hiddenState.properties.opacity = 0),
            Object(n.b)(t, "PercentSeries") &&
              (t.hiddenState.properties.opacity = 0),
            Object(n.b)(t, "FunnelSlice") &&
              ((t.defaultState.transitionDuration = 800),
              (t.hiddenState.transitionDuration = 1e3),
              (t.hiddenState.properties.opacity = 1)),
            Object(n.b)(t, "Slice") &&
              ((t.defaultState.transitionDuration = 700),
              (t.hiddenState.transitionDuration = 1e3),
              (t.hiddenState.properties.opacity = 1)),
            Object(n.b)(t, "Preloader") &&
              (t.hiddenState.transitionDuration = 2e3),
            Object(n.b)(t, "Column") &&
              ((t.defaultState.transitionDuration = 700),
              (t.hiddenState.transitionDuration = 1e3),
              (t.hiddenState.properties.opacity = 1)),
            Object(n.b)(t, "Column3D") &&
              (t.hiddenState.properties.opacity = 0);
        };
      window.am4themes_animated = a;
    },
  },
  ["lhmh"]
);
